import { withInstall } from '../../utils/with-install.mjs';
import './src/tag2.mjs';
export { tagEmits, tagProps } from './src/tag.mjs';
import script from './src/tag.vue_vue_type_script_lang.mjs';

const ElTag = withInstall(script);

export { ElTag, ElTag as default };
//# sourceMappingURL=index.mjs.map
